var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 262,
    viewBox: "0 0 227 262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.681 198.789H9.70475C5.61342 198.789 2.54492 195.72 2.54492 191.629V70.2531C2.54492 66.1618 5.61342 63.0933 9.70475 63.0933H217.34C221.431 63.0933 224.5 66.1618 224.5 70.2531V191.629C224.5 195.72 221.431 198.789 217.681 198.789Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9551 174.922L206.429 86.9583",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5042 181.742C60.5042 180.378 59.8223 179.356 58.4585 179.015L22.3185 174.582L41.7523 143.556C42.4342 142.534 42.0932 140.829 41.0704 140.147C40.0476 139.465 38.3429 139.806 37.661 140.829L16.1815 174.923C15.8405 175.605 15.8405 176.628 16.1815 177.31C16.5224 177.992 17.2043 178.674 17.8862 178.674L57.7767 183.788C58.1176 183.788 58.7995 183.788 59.1404 183.447C59.8223 183.106 60.1633 182.424 60.5042 181.742Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M186.654 121.735C185.631 121.054 185.29 119.69 185.972 118.326L205.406 87.3001L169.266 82.8679C167.902 82.8679 166.879 81.5041 167.22 80.1403C167.22 78.7765 168.584 77.7537 169.948 78.0946L209.838 83.2088C210.52 83.2088 211.202 83.8907 211.543 84.5726C211.884 85.2545 211.884 86.2773 211.543 86.9592L190.064 121.054C189.723 121.395 189.382 121.735 189.041 122.076C188.359 122.076 187.336 122.076 186.654 121.735Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M208.147 46.3847C185.644 19.4502 151.55 2.06201 113.705 2.06201C74.4965 2.06201 39.3793 20.473 16.877 49.1123",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M205.42 22.8595C204.738 22.8595 204.057 23.8823 204.398 24.5642L207.807 46.0437L186.668 39.9067C185.987 39.5657 184.964 40.2476 184.964 40.9295C184.623 41.6114 185.305 42.6342 185.987 42.6342L209.171 49.4531C209.512 49.4531 210.194 49.4531 210.535 49.1122C210.875 48.7712 211.216 48.4303 210.875 47.7484L207.125 23.8823C207.125 23.5414 207.125 23.2004 206.784 23.2004C206.443 22.8595 206.102 22.5185 205.42 22.8595Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M208.147 215.489C185.644 242.424 151.55 259.812 113.705 259.812C74.4965 259.812 39.3793 241.401 16.877 212.761",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M184.96 220.945C185.301 221.627 185.982 222.309 186.664 221.968L207.803 215.831L204.393 237.31C204.393 237.992 204.734 238.674 205.416 239.015C206.098 239.356 206.78 238.674 207.121 237.992L210.871 214.126C210.871 213.785 210.871 213.103 210.53 212.762C210.189 212.421 209.508 212.421 209.167 212.421L185.982 219.24C185.641 219.24 185.641 219.581 185.301 219.581C184.96 219.922 184.619 220.604 184.96 220.945Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 90.936H136.5",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M127.5 107.936H68.5",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M170.5 168.936H132.5",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.01358a1624269ef47e9b14b5d6c5857d.svg";
export { ForwardRef as ReactComponent };